import React from 'react';
import { Link } from 'react-router-dom';
import { List, ListItem, ListSubheader, ListItemText } from '@mui/material';

export default function ListMenu(props) {
    const mobileMenuList = [];

    props.menu.forEach(menu => {
        const subHeader = <ListSubheader sx={{color: 'white', bgcolor: 'inherit'}} key={menu.menuLabel}>{menu.menuLabel}</ListSubheader>;
        const menuItemList = [];

        menu.items.forEach((menuItem) => {
            const routeItem = props.routeAuth(menuItem.routeKey);
            if (routeItem) { // User is authorised for this route - show it
                const listItem = (
                <ListItem component={Link} to={routeItem.href} sx={{color: 'white', mr: 2, [`& > svg`]: {color: 'white', mr: 2}}} key={menuItem.itemLabel}>
                    { React.createElement(menuItem.icon, null, null) }
                    <ListItemText primary={menuItem.itemLabel} />
                </ListItem>
                );
                menuItemList.push(listItem);
            }
        });
        if (menuItemList.length > 0) {
            //
            // This user is allowed access to at least one item on this sub-menu. So show the sub-menu.
            //
            mobileMenuList.push(subHeader);
            mobileMenuList.push(menuItemList);
        }
    });

    return (
        <List>
            { mobileMenuList }
        </List>
    );
}
